import type { LoaderFunction } from 'react-router';

import type { RouteProps } from '../../../shared/RouteProps';

import { extractCompanyIdFromSlug } from '../../../shared/utils/extractCompanyIdFromSlug';
import { isTestAccount } from '../calculateShouldIndex';
import type { JobsModel } from './jobsModel';

export const jobsLoader =
  ({ services }: RouteProps): LoaderFunction =>
  async ({ params, request }): Promise<JobsModel> => {
    const companyId = extractCompanyIdFromSlug(params.companySlug);

    if (companyId === undefined) {
      throw new Error('Could not find companyId from params', params);
    }

    const url = new URL(request.url);
    const isDraft = url.searchParams.get('draft') === 'true';

    const companyDetails =
      await services.companyDetailsService.getCompanyDetails(
        companyId,
        Boolean(isDraft),
      );

    const jobs = await services.companyProfileService.getJobs(
      companyDetails?.companyProfile?.organisationId ?? undefined,
      1,
    );

    return {
      jobs: jobs.jobs,
      totalJobs: jobs.totalJobs,
      companyName: companyDetails.companyProfile.data.name ?? '',
      organisationId: companyDetails.companyProfile.organisationId ?? undefined,
      companyId,
      shouldIndex: Boolean(jobs.jobs.length) && !isTestAccount(companyDetails),
    };
  };
